import styled from 'styled-components';

export const Banner = styled.div`
  width: inherit;
  padding: ${({ theme }) => `${theme.spacing.xs} ${theme.spacing.sm}`};
  border-left: 4px solid ${({ theme }) => theme.colors.warning};
  color: ${({ theme }) => theme.colors.text.primary};
  background: ${({ theme }) => theme.colors.backgroundHover};
  font-family: ${({ theme }) => theme.fontFamily.semiBold};
  font-size: ${({ theme }) => theme.fontSize.sm};
  font-weight: ${({ theme }) => theme.fontWeight.semiBold};
  text-transform: uppercase;
`;
